import {createAction, ActionType} from 'typesafe-actions';
import {TTrack} from '../../../typings/todo';

export const trackChangedAction = createAction('TRACK_CHANGED')<{track: TTrack}>();

export type TrackChangedAction = ActionType<typeof trackChangedAction>;
